/**
 * Blob对象转换为文本
 *
 * @param {Blob} blob
 * @returns {Promise<string>}
 */
export function blobToText(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(blob);
  });
}

/**
 * 从对象中移除值为空的字段
 * @param {Object} obj
 * @returns {Object}
 */
export function omitEmptyStringFields(obj) {
  return Object.keys(obj).reduce((result, key) => {
    if (obj[key] !== '' || obj[key] !== null || obj[key] !== undefined) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}

/**
 * 创建枚举
 * @template T
 * @param {T} original
 * @param {boolean} [strict=false]
 * @returns {T}
 */
export function createEnum(original, strict) {
  return new Proxy(original, {
    get(_, key) {
      if (key === '__v_isRef') return false;

      if (strict && !Object.prototype.hasOwnProperty.call(original, key)) {
        throw new Error(`Unknown enum key: ${key}`);
      }

      return original[key];
    },
    set() {
      throw new Error('Cannot set enum value');
    },
  });
}

export const checkIsMobile = () => {
  const REG = /.*Mobile.*/;

  const { userAgent } = navigator;
  const isMobile = !!userAgent.match(REG);

  return isMobile;
};

export const checkIsPad = () => {
  const { userAgent } = navigator;
  const isAndroid = /(?:Android)/.test(userAgent);
  const isFireFox = /(?:Firefox)/.test(userAgent);
  const isPad =
    /(?:iPad|PlayBook)/.test(userAgent) ||
    (isAndroid && !/(?:Mobile)/.test(userAgent)) ||
    (isFireFox && /(?:Tablet)/.test(userAgent));

  return isPad;
};

export const isEmail = (str) => {
  const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+.([A-Za-z]{2,4})$/;
  return str && reg.test(str);
};

export const dataURLtoBlob = (dataurl) => {
  const arr = dataurl.split(',');
  const mime = (arr[0].match(/:(.*?);/) || ['', ''])[1];
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  // eslint-disable-next-line no-plusplus
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};
